export const LANDING_PAGE_URL = "https://afro-cargo.com";
export const HOST_API_URL = "https://api.afro-cargo.com/api";
// export const HOST_API_URL = "https://localhost:5000/api";
